import { createReducer } from "../../../common/reduxUtil";
import { SAT_SET_FEEDBACK, SAT_SET_START_ERROR } from "./types";

const initialState = {
  isFeedbackOpen: false,
  startError: null,
};

export default createReducer(initialState, {
  [SAT_SET_FEEDBACK]: (state, isFeedbackOpen) => ({
    ...state,
    isFeedbackOpen,
  }),
  [SAT_SET_START_ERROR]: (state, startError) => ({ ...state, startError }),
});
